import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const LedgerTypeService = {
  // Get all ledger types
  getList: async () => {
    try {
      const response = await instance.get("/accounting/ledger-types", {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching ledger types:", error);
      throw error;
    }
  },

  // Get a single ledger type by ID
  getById: async (id) => {
    try {
      const response = await instance.get(`/accounting/ledger-types/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching ledger type ${id}:`, error);
      throw error;
    }
  },

  // Create a new ledger type
  create: async (data) => {
    try {
      const response = await instance.post("/accounting/ledger-types", data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating ledger type:", error);
      throw error;
    }
  },

  // Update an existing ledger type
  update: async (id, data) => {
    try {
      const response = await instance.put(`/accounting/ledger-types/${id}`, data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating ledger type ${id}:`, error);
      throw error;
    }
  },

  // Delete a ledger type
  delete: async (id) => {
    try {
      const response = await instance.delete(`/accounting/ledger-types/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting ledger type ${id}:`, error);
      throw error;
    }
  },
};

export default LedgerTypeService;
